var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndustryWealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7296 28.7561C25.0083 28.7561 25.2344 28.5303 25.2344 28.2514C25.2344 27.9727 25.0083 27.7468 24.7296 27.7468H0.504776C0.226093 27.7468 0 27.9727 0 28.2514C0 28.5303 0.226093 28.7561 0.504776 28.7561H24.7296Z",
    fill: "#001EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54145 25.7281C4.82013 25.7281 5.04599 25.502 5.04599 25.2233C5.04599 24.9447 4.82013 24.7186 4.54145 24.7186H3.53188C3.2532 24.7186 3.02734 24.9447 3.02734 25.2233C3.02734 25.502 3.2532 25.7281 3.53188 25.7281H4.54145Z",
    fill: "#001EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54145 22.7C4.82013 22.7 5.04599 22.4742 5.04599 22.1953C5.04599 21.9166 4.82013 21.6907 4.54145 21.6907H3.53188C3.2532 21.6907 3.02734 21.9166 3.02734 22.1953C3.02734 22.4742 3.2532 22.7 3.53188 22.7H4.54145Z",
    fill: "#001EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54145 19.6714C4.82013 19.6714 5.04599 19.4456 5.04599 19.1669C5.04599 18.8882 4.82013 18.6621 4.54145 18.6621H3.53188C3.2532 18.6621 3.02734 18.8882 3.02734 19.1669C3.02734 19.4456 3.2532 19.6714 3.53188 19.6714H4.54145Z",
    fill: "#001EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54145 16.644C4.82013 16.644 5.04599 16.4181 5.04599 16.1392C5.04599 15.8605 4.82013 15.6346 4.54145 15.6346H3.53188C3.2532 15.6346 3.02734 15.8605 3.02734 16.1392C3.02734 16.4181 3.2532 16.644 3.53188 16.644H4.54145Z",
    fill: "#001EFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54145 13.6154C4.82013 13.6154 5.04599 13.3895 5.04599 13.1109C5.04599 12.8322 4.82013 12.6061 4.54145 12.6061H3.53188C3.2532 12.6061 3.02734 12.8322 3.02734 13.1109C3.02734 13.3895 3.2532 13.6154 3.53188 13.6154H4.54145Z",
    fill: "#001EFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54145 10.5874C4.82013 10.5874 5.04599 10.3615 5.04599 10.0826C5.04599 9.80392 4.82013 9.57806 4.54145 9.57806H3.53188C3.2532 9.57806 3.02734 9.80392 3.02734 10.0826C3.02734 10.3615 3.2532 10.5874 3.53188 10.5874H4.54145Z",
    fill: "#001EFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58202 10.5874C8.86093 10.5874 9.08679 10.3615 9.08679 10.0826C9.08679 9.80392 8.86093 9.57806 8.58202 9.57806H6.56337C6.28469 9.57806 6.05859 9.80392 6.05859 10.0826C6.05859 10.3615 6.28469 10.5874 6.56337 10.5874H8.58202Z",
    fill: "#001EFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58202 13.6154C8.86093 13.6154 9.08679 13.3895 9.08679 13.1109C9.08679 12.8322 8.86093 12.6061 8.58202 12.6061H6.56337C6.28469 12.6061 6.05859 12.8322 6.05859 13.1109C6.05859 13.3895 6.28469 13.6154 6.56337 13.6154H8.58202Z",
    fill: "#001EFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58202 16.644C8.86093 16.644 9.08679 16.4181 9.08679 16.1392C9.08679 15.8605 8.86093 15.6346 8.58202 15.6346H6.56337C6.28469 15.6346 6.05859 15.8605 6.05859 16.1392C6.05859 16.4181 6.28469 16.644 6.56337 16.644H8.58202Z",
    fill: "#001EFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58202 19.6714C8.86093 19.6714 9.08679 19.4456 9.08679 19.1669C9.08679 18.8882 8.86093 18.6621 8.58202 18.6621H6.56337C6.28469 18.6621 6.05859 18.8882 6.05859 19.1669C6.05859 19.4456 6.28469 19.6714 6.56337 19.6714H8.58202Z",
    fill: "#001EFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58202 22.7C8.86093 22.7 9.08679 22.4742 9.08679 22.1953C9.08679 21.9166 8.86093 21.6907 8.58202 21.6907H6.56337C6.28469 21.6907 6.05859 21.9166 6.05859 22.1953C6.05859 22.4742 6.28469 22.7 6.56337 22.7H8.58202Z",
    fill: "#001EFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58202 25.7281C8.86093 25.7281 9.08679 25.502 9.08679 25.2233C9.08679 24.9447 8.86093 24.7186 8.58202 24.7186H6.56337C6.28469 24.7186 6.05859 24.9447 6.05859 25.2233C6.05859 25.502 6.28469 25.7281 6.56337 25.7281H8.58202Z",
    fill: "#001EFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7012 19.6714C21.9798 19.6714 22.2057 19.4456 22.2057 19.1669C22.2057 18.8882 21.9798 18.6621 21.7012 18.6621H19.6823C19.4036 18.6621 19.1777 18.8882 19.1777 19.1669C19.1777 19.4456 19.4036 19.6714 19.6823 19.6714H21.7012Z",
    fill: "#001EFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7012 22.7C21.9798 22.7 22.2057 22.4742 22.2057 22.1953C22.2057 21.9166 21.9798 21.6907 21.7012 21.6907H19.6823C19.4036 21.6907 19.1777 21.9166 19.1777 22.1953C19.1777 22.4742 19.4036 22.7 19.6823 22.7H21.7012Z",
    fill: "#001EFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7012 25.7281C21.9798 25.7281 22.2057 25.502 22.2057 25.2233C22.2057 24.9447 21.9798 24.7186 21.7012 24.7186H19.6823C19.4036 24.7186 19.1777 24.9447 19.1777 25.2233C19.1777 25.502 19.4036 25.7281 19.6823 25.7281H21.7012Z",
    fill: "#001EFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.664 16.644C17.9427 16.644 18.1686 16.4181 18.1686 16.1392C18.1686 15.8605 17.9427 15.6346 17.664 15.6346H15.6454C15.3665 15.6346 15.1406 15.8605 15.1406 16.1392C15.1406 16.4181 15.3665 16.644 15.6454 16.644H17.664Z",
    fill: "#001EFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.664 19.6714C17.9427 19.6714 18.1686 19.4456 18.1686 19.1669C18.1686 18.8882 17.9427 18.6621 17.664 18.6621H15.6454C15.3665 18.6621 15.1406 18.8882 15.1406 19.1669C15.1406 19.4456 15.3665 19.6714 15.6454 19.6714H17.664Z",
    fill: "#001EFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.664 22.7C17.9427 22.7 18.1686 22.4742 18.1686 22.1953C18.1686 21.9166 17.9427 21.6907 17.664 21.6907H15.6454C15.3665 21.6907 15.1406 21.9166 15.1406 22.1953C15.1406 22.4742 15.3665 22.7 15.6454 22.7H17.664Z",
    fill: "#001EFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.664 25.7281C17.9427 25.7281 18.1686 25.502 18.1686 25.2233C18.1686 24.9447 17.9427 24.7186 17.664 24.7186H15.6454C15.3665 24.7186 15.1406 24.9447 15.1406 25.2233C15.1406 25.502 15.3665 25.7281 15.6454 25.7281H17.664Z",
    fill: "#001EFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54145 7.5593C4.82013 7.5593 5.04599 7.33345 5.04599 7.05476C5.04599 6.77608 4.82013 6.54999 4.54145 6.54999H3.53188C3.2532 6.54999 3.02734 6.77608 3.02734 7.05476C3.02734 7.33345 3.2532 7.5593 3.53188 7.5593H4.54145Z",
    fill: "#001EFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6098 25.7281C11.8885 25.7281 12.1143 25.502 12.1143 25.2233C12.1143 24.9447 11.8885 24.7186 11.6098 24.7186H10.6005C10.3216 24.7186 10.0957 24.9447 10.0957 25.2233C10.0957 25.502 10.3216 25.7281 10.6005 25.7281H11.6098Z",
    fill: "#001EFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6098 22.7C11.8885 22.7 12.1143 22.4742 12.1143 22.1953C12.1143 21.9166 11.8885 21.6907 11.6098 21.6907H10.6005C10.3216 21.6907 10.0957 21.9166 10.0957 22.1953C10.0957 22.4742 10.3216 22.7 10.6005 22.7H11.6098Z",
    fill: "#001EFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6098 19.6714C11.8885 19.6714 12.1143 19.4456 12.1143 19.1669C12.1143 18.8882 11.8885 18.6621 11.6098 18.6621H10.6005C10.3216 18.6621 10.0957 18.8882 10.0957 19.1669C10.0957 19.4456 10.3216 19.6714 10.6005 19.6714H11.6098Z",
    fill: "#001EFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6098 16.644C11.8885 16.644 12.1143 16.4181 12.1143 16.1392C12.1143 15.8605 11.8885 15.6346 11.6098 15.6346H10.6005C10.3216 15.6346 10.0957 15.8605 10.0957 16.1392C10.0957 16.4181 10.3216 16.644 10.6005 16.644H11.6098Z",
    fill: "#001EFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6098 13.6154C11.8885 13.6154 12.1143 13.3895 12.1143 13.1109C12.1143 12.8322 11.8885 12.6061 11.6098 12.6061H10.6005C10.3216 12.6061 10.0957 12.8322 10.0957 13.1109C10.0957 13.3895 10.3216 13.6154 10.6005 13.6154H11.6098Z",
    fill: "#001EFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6098 10.5874C11.8885 10.5874 12.1143 10.3615 12.1143 10.0826C12.1143 9.80392 11.8885 9.57806 11.6098 9.57806H10.6005C10.3216 9.57806 10.0957 9.80392 10.0957 10.0826C10.0957 10.3615 10.3216 10.5874 10.6005 10.5874H11.6098Z",
    fill: "#001EFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1312 7.58575C14.1312 7.40637 14.0359 7.24039 13.8812 7.14999L1.76906 0.0697706C1.43261 -0.126973 1.00977 0.115787 1.00977 0.505288V28.7565H2.01909V1.37559L13.1221 7.8668V28.7565H14.1314L14.1312 7.58575Z",
    fill: "#001EFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9758 16.2341C24.1305 16.3247 24.2258 16.4905 24.2258 16.6698V28.7561H23.2163V16.9511L13.123 11.0497V9.89008L23.9758 16.2341Z",
    fill: "#001EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryWealth);
export default __webpack_public_path__ + "static/media/industry-wealth.c3536681d8c46a6dc23ff58df575f26c.svg";
export { ForwardRef as ReactComponent };